/** Accounting calendar of the admin: Moscow days (owner 2026-10-22 — every accounting and finance
 *  period boundary is Europe/Moscow, whatever the browser's time zone). Pure. */

const MSK_DATE = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Moscow', year: 'numeric', month: '2-digit', day: '2-digit' })

/** «2026-10-23» — today in Moscow at `now`. */
export function moscowToday(now: Date = new Date()): string {
  return MSK_DATE.format(now)
}

/** «2026-10-01» — the first day of the Moscow month at `now`. */
export function moscowMonthStart(now: Date = new Date()): string {
  return `${moscowToday(now).slice(0, 8)}01`
}
